import Vue from "vue";
import Router from "vue-router";
import PageIndex from "../pages";
import pageRouters from "./pageRouters";

Vue.use(Router);

export const constantRoutes = [
  {
    path: "/",
    redirect: "/login",
    component: PageIndex,
    children: [...pageRouters]
  },
  {
    path: "/user",
    redirect: "/user/course/hone",
    component: PageIndex,
    children: [...pageRouters]
  },
  {
    path: "/teacher",
    redirect: "/teacher/course/home",
    component: PageIndex,
    children: [...pageRouters]
  },
  {
    path: "/confirmIdentity",
    redirect: "/confirmIdentity",
    component: PageIndex,
    children: [...pageRouters]
  }
];

//export default router;
export default new Router({
  /*  mode: 'history',*/
  mode: "history", // 去掉url中的#
  base: "/",
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
});



// WEBPACK FOOTER //
// ./src/router/index.js